import getFormatDate from './get-format-date';

type Props = {
	startTime: string;
	endTime: string;
	locale: string;
	timezone: string;
};

const timeFormat = 'LT';

const getStartEndTime = ({ startTime, endTime, locale, timezone }: Props) => {
	const formatedStartTime = getFormatDate({ date: startTime, format: timeFormat, locale, timezone });
	const formatedEndTime = getFormatDate({ date: endTime, format: timeFormat, locale, timezone });

	return `${formatedStartTime} - ${formatedEndTime}`;
};

export default getStartEndTime;
